import { InvestorDocument } from "@tudigo-monorepo/core-tudigo-api-models";
import { CollectionRequestParams } from "@tudigo-monorepo/web-tudigo-api-client";

import { ContentType, Request, RequestParams, TudigoResponse } from "../api";

export type GetInvestorDocumentsQueryParams = CollectionRequestParams<
  { userId: string },
  { refId: string | string[] }
>;

export const investorDocumentsEndpoints = (request: Request) => ({
  /**
   * No description
   *
   * @name getInvestorDocuments
   * @summary get investor documents
   * @request GET:/api/v1/users/{userId}/investor-documents
   * @secure
   */
  getInvestorDocuments: (
    queryParams: GetInvestorDocumentsQueryParams,
    params: RequestParams = {},
  ) => {
    const { pathParams, ...query } = queryParams || {};

    return request<TudigoResponse<InvestorDocument[]>, void>({
      path: `/api/v1/users/${pathParams?.userId}/investor-documents`,
      method: "GET",
      query: {
        fields: query.fields,
        ...query.filters,
        ...query.pagination,
        ...query.sorting,
      },
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  },
});
